import React from 'react'
import {useAtom} from "jotai";
import { useLocation, Navigate } from 'react-router-dom';
import { userAtom, userTokenAtom } from '../atoms/globalStates';

const Secure = ({ children }) => {
    
    const user = JSON.parse(localStorage.getItem("user"));
    let location = useLocation();


    if (!user) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return children;
  };
export default Secure
